export default __webpack_public_path__ + "static/after-support-thumbnail-first-d36d71ee5821b816d6128cacbf75004d.avif";